module.exports = __webpack_public_path__ + "img/kriti.02d020e2.jpg";